import p from "./ApIndicator.vue.js";
import { resolveComponent as s, openBlock as a, createBlock as c, Transition as d, withCtx as l, withDirectives as o, createElementVNode as t, normalizeStyle as m, createVNode as f, toDisplayString as v, vShow as n, withModifiers as u } from "vue";
/* empty css                 */
import y from "../../_virtual/_plugin-vue_export-helper.js";
const _ = { class: "ap-indicator" };
function h(e, i, w, x, S, $) {
  const r = s("spinner");
  return a(), c(d, { name: "ap-indicator" }, {
    default: l(() => [
      o(t("div", _, [
        t("div", {
          class: "ap-indicator-wrapper",
          style: m({ padding: e.text ? "20px" : "15px" })
        }, [
          f(r, {
            class: "ap-indicator-spin",
            type: e.convertedSpinnerType,
            size: 32
          }, null, 8, ["type"]),
          o(t("span", { class: "ap-indicator-text" }, v(e.text), 513), [
            [n, e.text]
          ])
        ], 4),
        t("div", {
          class: "ap-indicator-mask",
          onTouchmove: i[0] || (i[0] = u(() => {
          }, ["stop", "prevent"]))
        }, null, 32)
      ], 512), [
        [n, e.visible]
      ])
    ]),
    _: 1
  });
}
const B = /* @__PURE__ */ y(p, [["render", h]]);
export {
  B as default
};
